import { skipToken } from '@reduxjs/toolkit/query';
import { useGetConsumerApplicationsV2CreditApplicationsApplicationIdLenderRequirementsQuery, usePostConsumerApplicationsV2CreditApplicationsApplicationIdEdsVerifyMutation, usePostConsumerApplicationsV2CreditApplicationsApplicationIdEdsEventsMutation, } from 'consumer-applications-v2-api';
export const useApplicationEDS = ({ applicationId, }) => {
    // API - GET
    const { data: lenderRequirements, isLoading: isLoadingLenderReqs } = useGetConsumerApplicationsV2CreditApplicationsApplicationIdLenderRequirementsQuery(applicationId ? { applicationId } : skipToken);
    // API - POST
    const [postVerifyEDS, { data: edsVerifyResp, isLoading: isLoadingEdsVerify },] = usePostConsumerApplicationsV2CreditApplicationsApplicationIdEdsVerifyMutation();
    const [postEventsEDS, { data: edsEventsResp, isLoading: isLoadingEdsEvents },] = usePostConsumerApplicationsV2CreditApplicationsApplicationIdEdsEventsMutation();
    return {
        lenderRequirements,
        edsVerifyResp,
        edsEventsResp,
        isLoadingLenderReqs,
        isLoadingEdsVerify,
        isLoadingEdsEvents,
        postVerifyEDS,
        postEventsEDS,
    };
};
